import React from "react";
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from "react-router-dom";

import MainContainer from "./Main";
import "./App.scss";



export const App = () => (
    <div className="app">
      <Switch>
        <Route exact path="/" component={MainContainer} />
        <Route path="/login" component={MainContainer} />
        <Route path="/username-password" component={MainContainer} />
        <Route path="/iid-manual" component={MainContainer} />
        <Route path="/iid" component={MainContainer} />
        <Route path="/otp" component={MainContainer} />
        <Route path="/password" component={MainContainer} />
        <Route path="/password-reset" component={MainContainer} />
        <Route path="/pin" component={MainContainer} />
        <Route path="/enrollsms" component={MainContainer} />
        <Route path="/enrollimprivataid" component={MainContainer} />
        <Route path="/sms" component={MainContainer} />
        <Route path="/tempcode" component={MainContainer} />
        <Route path="/autherror" component={MainContainer} />
        <Route path="/choosemodality" component={MainContainer} />
        <Route path="/devicelist" component={MainContainer} />
      </Switch>
    </div>
  );

export default withRouter(connect()(App));



// WEBPACK FOOTER //
// ./src/containers/App.js